export type { SearchTextMatchPriorityOptions } from './getSearchTextMatchPriority';
export type { SearchTextMatchSortMeta } from './getSearchTextMatchPriority';

export {
  compareSearchTextMatchSortMeta,
  getSearchTextMatchHighlightSpan,
  getSearchTextMatchPriority,
  getSearchTextMatchSortMeta,
  isSearchKeywordEmpty,
  SEARCH_TEXT_MATCH_PRIORITY,
} from './getSearchTextMatchPriority';
export { compareSearchTextMatchPriority, sortBySearchTextMatch } from './searchTextMatchSort';
